export const DELETE_DMX_DEVICE = 'DELETE_DMX_DEVICE';
export const DELETE_DMX_DEVICE_SUCCESSFUL = 'DELETE_DMX_DEVICE_SUCCESSFUL';
export const DELETE_DMX_DEVICE_FAILED = 'DELETE_DMX_DEVICE_FAILED';
